import styled from 'styled-components';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';


export const NavItemIcon = styled(Icon)`
  width: 2rem;
  min-width: 2rem;
  margin-right: 0.7rem;
  color: ${props => props.theme.colors.text};
  transition: 200ms;

`;

export const NavItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 1.6rem;
  text-decoration: none;
  width: 100%;

  cursor: pointer;

  padding-inline: 10px;
  padding-block: 20px;
  
  &:hover {
    background-color: ${props => props.theme.colors.primary_hover};
    color: ${props => props.theme.colors.white};
    transition: 500ms;
  }
    &:hover > ${NavItemIcon} {
      color: ${props => props.theme.colors.white};
    }
`;

export const NavItemTitle = styled.span`
    margin-top: 2px;
    display: inline;
    font-size: 12px;
    transition: 200ms;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;

  cursor: pointer
`;
